import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

export default function useECharts(domRef, deps = []) {
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!domRef.current) return;

    // Dispose previous instance if exists
    if (chartInstance.current) {
      chartInstance.current.dispose();
      chartInstance.current = null;
    }

    // Initialize new instance
    chartInstance.current = echarts.init(domRef.current);

    // Cleanup on unmount or deps change
    return () => {
      if (chartInstance.current) {
        chartInstance.current.dispose();
        chartInstance.current = null;
      }
    };
    // eslint-disable-next-line
  }, [domRef, ...deps]);

  return chartInstance;
} 